import React from "react";
import { Badge } from "antd";

interface Props {
  count: number;
}

const SurveyAreaBadge = ({ count }: Props) => {
  if (!count || count <= 0) return null;

  return (
    <Badge
      count={count}
      size="small"
      style={{ backgroundColor: "#fa8c16", marginLeft: 6 }}
      title={`${count} out-of-range species`}
    />
  );
};

export default SurveyAreaBadge;
